import { TableCellTypes } from '@nttp/enum/table-cell-type-enum';

export const BeneficiaryColumns = [
    {
        title: 'Beneficiary name',
        name: 'recipientName',
        class: 'no-upscope',
        width: '130px'
    },
    {
        title: 'Account number/IBAN',
        name: 'accountNumberIban',
        class: 'no-upscope',
        width: '280px'
    },
    {
        title: 'Bank country',
        name: 'bankCountry',
        width: '130px'
    },
    {
        title: 'Currency',
        name: 'currency',
        width: '95px'
    },
    {
        title: 'Payment Mandate',
        name: 'paymentMandate',
        width: '95px'
    },
    {
        title: 'Last payment date',
        name: 'lastPaymentDate',
        type: TableCellTypes.Date,
        width: '150px'
    },
    {
        title: 'Last payment amount',
        name: 'lastPaymentAmount',
        type: TableCellTypes.Number,
        class: 'text-right',
        width: '165px'
    },
    {
        title: 'Updated by',
        name: 'updatedBy',
        width: '120px'
    },
    {
        title: 'Last updated date',
        name: 'lastUpdatedDate',
        type: TableCellTypes.Date,
        width: '150px'
    }
];

export const RemitterColumn = {
    title: 'Ultimate Remitter',
    name: 'ultimateRemitter',
    width: '130px'
};
